import { render, staticRenderFns } from "./Blogs.vue?vue&type=template&id=44fd877a&scoped=true"
import script from "./Blogs.vue?vue&type=script&lang=js"
export * from "./Blogs.vue?vue&type=script&lang=js"
import style0 from "./Blogs.vue?vue&type=style&index=0&id=44fd877a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fd877a",
  null
  
)

export default component.exports